/* eslint-disable react/react-in-jsx-scope,react/jsx-no-bind */

import React, { useCallback, useEffect, useReducer, useState } from "react";
import { SearchMajor } from "@shopify/polaris-icons";
import {
  Icon,
  Modal,
  ResourceItem,
  ResourceList,
  Spinner,
  TextField,
  TextStyle,
} from "@shopify/polaris";

import {
  reducerActions,
  resourcePickerReducers,
} from "./resourcePickerReducers";
import { getReviewsRes } from "./services";
import { ReactComponent as StarSolid } from "../../assets/icons/star.svg";

export default function ReviewDataPicker() {
  const [state, dispatch] = useReducer(reducerActions, resourcePickerReducers);
  const [, setAction] = useState(0);
  const [typing] = useState({
    timeoutScroll: 0,
    timeoutTyping: 0,
    limit: 25,
    search: "",
    page: 0,
    dataNodes: {},
  });
  const [countIndex, setCountIndex] = useState(0);
  const [next, setNext] = useState(1);
  const [open, setOpen] = useState(false);
  const [focused, setFocused] = useState(false);
  const [firstRes, setFirstRes] = useState(false);
  const [search, setSearch] = useState(null);
  const [loading, setLoading] = useState(true);
  const [searchLoading, setSearchLoading] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [listItems, setListItems] = useState([]);
  const [newListItemShows, setNewListItemShows] = useState([]);
  const [pageInfo, setPageInfo] = useState({
    limit: typing.limit,
    search: typing.search,
    page: typing.page,
  });

  // eslint-disable-next-line
  const onSelectionChange = useCallback(setSelectedItems, []);

  const onScrolledToBottom = useCallback(() => {
    if (!loading && !searchLoading && pageInfo.count >= pageInfo.limit) {
      typing.page = pageInfo.page;
      setLoading(true);

      clearTimeout(typing.timeoutScroll);
      typing.timeoutScroll = setTimeout(() => setNext((v) => v + 1), 300);
    }
    // eslint-disable-next-line
  }, [loading, searchLoading, pageInfo]);

  const closePopup = useCallback(() => {
    dispatch({ type: "setOpenReviewPicker", payload: false });
    setLoading(false);
    setSearchLoading(false);
    setSelectedItems([]);
  }, []);

  const addItems = () => {
    const selectedMap = {};
    selectedItems.forEach((key) => {
      selectedMap[key] = typing.dataNodes[key];
    });
    dispatch({ type: "onSelected", payload: selectedMap });
    closePopup();
  };

  function renderItem(item) {
    const {
      id,
      // key_exists,
      // status_rev,
      author,
      email,
      // location,
      review_rating,
      review_title,
      review_message,
      // product_image_url,
      countIndex,
    } = item;
    return (
      <div
        key={id}
        className="resource-list--item-picker"
        style={{ marginTop: `${65 * countIndex}px` }}
      >
        <ResourceItem id={id} title={review_message}>
          <TextStyle>
            <div
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: "400px",
              }}
              title={review_message}
            >
              <div className="flex ak-color-rating">
                <span
                  className={
                    review_rating >= 1 ? "item-rate active" : "item-rate"
                  }
                >
                  <StarSolid />
                </span>
                <span
                  className={
                    review_rating >= 2 ? "item-rate active" : "item-rate"
                  }
                >
                  <StarSolid />
                </span>
                <span
                  className={
                    review_rating >= 3 ? "item-rate active" : "item-rate"
                  }
                >
                  <StarSolid />
                </span>
                <span
                  className={
                    review_rating >= 4 ? "item-rate active" : "item-rate"
                  }
                >
                  <StarSolid />
                </span>
                <span
                  className={
                    review_rating >= 5 ? "item-rate active" : "item-rate"
                  }
                >
                  <StarSolid />
                </span>
                <div style={{ position: "relative", top: "-5px", left: "5px" }}>
                  {author} ({email})
                </div>
              </div>
              {review_title} {review_message}
            </div>
          </TextStyle>
        </ResourceItem>
      </div>
    );
  }

  function resp(res = { data: [] }) {
    if (!firstRes) setFirstRes(true);
    setLoading(false);
    setSearchLoading(false);
    const { limit, page, search, data } = res || {};
    if (data) {
      setPageInfo({ limit, page, search, count: data.length });
      let newCountIndex = countIndex;
      const dataNewNodes = [];
      data.forEach(
        ({
          id,
          // key_exists,
          status_rev,
          author,
          email,
          location,
          review_rating,
          review_title,
          review_message,
          product_image_url,
        }) => {
          if (!typing.dataNodes[id]) {
            const item = {
              id,
              // key_exists,
              status_rev,
              author,
              email,
              location,
              review_rating,
              review_title,
              review_message,
              product_image_url,

              countIndex: newCountIndex,
            };
            typing.dataNodes[id] = item;
            dataNewNodes.push(item);
            newCountIndex++;
          }
        },
      );
      setCountIndex(newCountIndex);
      if (dataNewNodes.length > 0) {
        setListItems((v) => [...v, ...dataNewNodes]);
        setNewListItemShows((v) =>
          v.length > 0 ? v : dataNewNodes.slice(0, 10),
        );
      }
    }
  }

  useEffect(() => {
    if (open && next > 0) {
      getReviewsRes(typing.limit, typing.search, typing.page).then(resp);
    }
    // eslint-disable-next-line
  }, [open, next]);

  useEffect(() => {
    if (open && firstRes && search !== null) {
      setNext(0);
      typing.page = 0;
      typing.search = search;
      setCountIndex(0);
      clearTimeout(typing.timeoutTyping);
      typing.timeoutTyping = setTimeout(() => {
        typing.dataNodes = {};
        setListItems([]);
        setNewListItemShows([]);
        setSearchLoading(true);
        getReviewsRes(typing.limit, typing.search, typing.page).then(resp);
      }, 1000);
    }
    // eslint-disable-next-line
  }, [open, firstRes, search]);

  useEffect(() => {
    if (listItems.length > 0)
      listItems.forEach((item, index) => {
        item.countIndex = index;
      });
  }, [listItems]);

  useEffect(() => {
    if (state.openReviewPicker && !open) setOpen(true);
    if (state.openReviewPicker) {
      setTimeout(() => {
        setFocused(true);
        setNewListItemShows(listItems.slice(0, 10));
      }, 200);
    } else {
      setFocused(false);
    }
    // eslint-disable-next-line
  }, [state.openReviewPicker]);

  useEffect(() => {
    dispatch({
      type: "setActionResourceDataPickerReview",
      payload: setAction,
    });
  }, []);

  return (
    <Modal
      open={state.openReviewPicker}
      title="Select Review"
      // onScrolledToBottom={onScrolledToBottom}
      noScroll
      onClose={closePopup}
      primaryAction={{
        content: "Add",
        onAction: addItems,
        disabled: selectedItems.length === 0,
      }}
      secondaryActions={[
        {
          content: "Cancel",
          onAction: closePopup,
          disabled: false,
        },
      ]}
      footer={`${selectedItems.length} review${selectedItems.length > 1 ? "s" : ""} selected`}
    >
      <Modal.Section key="search">
        <TextField
          label=""
          focused={focused}
          labelHidden
          clearButton
          onClearButtonClick={() => {
            if (!searchLoading && !loading) setSearch("");
          }}
          prefix={
            searchLoading ? (
              <Spinner size="small" />
            ) : (
              <Icon source={SearchMajor} color="base" />
            )
          }
          value={search || ""}
          onChange={(value) => {
            if ((!searchLoading && !loading) || !firstRes) setSearch(value);
          }}
          placeholder="Search reviews"
          autoComplete=""
        />
      </Modal.Section>
      <div
        className="modal-resource-picker-graphql"
        style={{ height: `${listItems.length * 65}px` }}
        onScroll={({ target }) => {
          const { scrollTop, offsetHeight } = target;
          const newList = listItems.filter((item) => {
            return (
              item.countIndex * 65 + 65 >= scrollTop &&
              item.countIndex * 65 <= scrollTop + offsetHeight
            );
          });
          setNewListItemShows(newList);
          if (scrollTop + offsetHeight > listItems.length * 65)
            onScrolledToBottom();
        }}
      >
        <ResourceList
          loading={loading}
          items={newListItemShows}
          renderItem={renderItem}
          selectedItems={selectedItems}
          onSelectionChange={onSelectionChange}
          selectable
        />
        <div
          style={{
            position: "absolute",
            marginTop: `${listItems.length * 65}px`,
          }}
        >
          &nbsp;
        </div>
      </div>
    </Modal>
  );
}
